<template>
  <mv-page>
    <v-flex xs1 class="hidden-md-and-down" style="position:fixed; top: 70px">
      <h2 class="font-weight-light">Проходы</h2>
    </v-flex>
    <mv-med-row>
      <v-layout row wrap>
        <v-flex xs12>
          <v-subheader class="pl-0 px-0">
            <v-btn icon small flat color="primary" @click="prev">
              <v-icon dark>keyboard_arrow_left</v-icon>
            </v-btn>
            <v-menu offset-y left>
              <div slot="activator" style="display: inline-block; width: 50px"
              class="text-xs-center primary--text"
              >{{month}}</div>
              <v-date-picker dense
              locale="ru" first-day-of-week="1" type="month"
              v-model="monthPick" :reactive="true" color="#f2c44f">
              </v-date-picker>
            </v-menu>
            <v-btn icon flat color="primary" @click="next">
              <v-icon dark>keyboard_arrow_right</v-icon>
            </v-btn>
          </v-subheader>
        </v-flex>
        <v-flex xs12>
          <v-list v-if="events" dense two-line @scroll.native="handleScroll">
            <v-subheader v-if="nodata && dates.length === 0">Нет данных за период</v-subheader>
            <div v-observe-visibility="probablyPageBottom"></div>
            <template v-for="date in dates" >
              <v-subheader class="text-xs-center mt-3" :key="date">
                <v-divider></v-divider>
                {{date}}
                <v-divider></v-divider>
              </v-subheader>
              <v-list-tile avatar v-for="ev in events[date].evs" :key="ev.eventid">
                <v-list-tile-avatar class="hidden-xs-only"
                :color="ev.direction === 'выход' ? '#00E676' : ev.direction === 'вход' ? '#5fb2e2' : '#FFB74D'">
                  <v-icon
                  class="lighten-1 white--text"
                  >{{directionIcon(ev.direction)}}</v-icon>
                </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>Карта {{ev.cardid}}: {{ev.direction}}</v-list-tile-title>
                    <v-list-tile-sub-title class="text--primary"></v-list-tile-sub-title>
                    <v-list-tile-sub-title>{{getDate(ev.originalts)}}</v-list-tile-sub-title>
                  </v-list-tile-content>
                  <br />
              </v-list-tile>
            </template>
          </v-list>
          <v-progress-linear v-else :indeterminate="true"></v-progress-linear>
          <mv-page-bottom-progress v-show="moreProgress"></mv-page-bottom-progress>
        </v-flex>
      </v-layout>
    </mv-med-row>
  </mv-page>
</template>

<script>
import moment from 'moment'
import debounce from 'debounce'
export default {
  name: 'events',
  data: () => ({
    start: moment().startOf('month').format('YYYY-MM-DD'),
    events: null,
    dialog: false,
    calendar: null,
    more: moment().startOf('month').format('YYYY-MM-DD'),
    moreProgress: false,
    moreWasEmptyTimes: 0,
    nodata: false,
    detailsDialog: false,
    detailsFor: null,
    monthPick: moment().startOf('month').format('YYYY-MM'),
    balance: null,
  }),
  computed: {
    profile () {
      return this.$store.state.profile
    },
    month () {
      return moment(this.start).startOf('month').format('MMMM YYYY')
    },
    dates () {
      if (!this.events) return []
      return Object.keys(this.events)
      .sort().reverse()
    }
  },
  methods: {
    async fetch () {
      this.nodata = false
      const { events } = await this.fetchEvents()
      this.events = events
      this.nodata = events === undefined ? true : false
    },
    async fetchEvents (month) {
      const data = await this.$store.dispatch('sioRequest', {
        topic: 'events-by-month',
        pl: {
          month: month || this.start
        }
      })
      return data
    },
    async addMore () {
      this.more = moment(this.more).subtract(1, 'months').startOf('month').format('YYYY-MM-DD')
      const { events, meta } = await this.fetchEvents(this.more)
      if (events !== undefined) {
        this.events = Object.assign(events, this.events)
        this.moreProgress = false
        if (meta.count < 5 && meta.count !== 0) {
          this.moreProgress = true
          this.syncMore()
        } else {
          if (meta.count === 0 && this.moreWasEmptyTimes < 3 ) {
            this.moreWasEmptyTimes++
            this.moreProgress = true
            this.syncMore()
          } else {
            this.moreWasEmptyTimes = 0
          }
        }
      }
    },
    async updateInterval () {
      this.fetch()
    },
    prev () {
      if (this.calendar) {
        this.$refs.calendar.prev()
      } else {
        this.start = moment(this.start).subtract(1, 'months').startOf('month').format('YYYY-MM-DD')
      }
    },
    next () {
      if (this.calendar) {
        this.$refs.calendar.next()
      } else {
        this.start = moment(this.start).add(1, 'months').startOf('month').format('YYYY-MM-DD')
      }
    },
    directionIcon (direction) {
      if (direction.toLowerCase() === 'вход') return 'login'
      if (direction.toLowerCase() === 'выход') return 'logout'
      if (direction.toLowerCase() === 'проход') return 'remove_circle'
      return '*'
    },
    getDate (date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    probablyPageBottom (isVisible) {
      if (isVisible && this.events) {
        this.moreProgress = true
        this.syncMore()
      }
    }
  },
  watch: {
    async profile (val) {
      if (val) await this.fetch()
    },
    start (val, old) {
      this.events = null
      if (typeof val === 'object') {
        this.start = old
      }
      if (this.events !== undefined) {
        this.more = val
        this.syncStart(val)
      }
    },
    monthPick (val) {
      if (val) this.start = moment(val).startOf('month').format('YYYY-MM-DD')
    },
    calendar (val) {
      if (val !== null) localStorage.setItem('detiEventsCalendar', val)
    },
  },
  async mounted () {
    if (this.profile) await this.fetch()
  },
  created () {
    this.syncStart = debounce(this.updateInterval, 600)
    this.syncMore = debounce(this.addMore, 1000)
    const calendar = JSON.parse(localStorage.getItem('detiEventsCalendar'))
    if (calendar === null) {
      this.calendar = false
    } else {
      this.calendar = calendar
    }
  }
}
</script>
